import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * Freelance and manual work hours are a TAB of the attendance requests screen,
 * not a screen of their own: HR decides them beside the other attendance
 * requests. This path stays only so an old link still lands
 * somewhere useful; it renders nothing itself.
 *
 * There is no grant guard here any more. The target runs its own, and a
 * second one would decide the same question with a worse error.
 */
export const Route = createFileRoute('/_authenticated/hr/work-entries')({
  beforeLoad: () => {
    throw redirect({ to: '/hr/attendance-corrections', search: { tab: 'freelance-hours' } })
  },
})
